import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-flag-geo',
  templateUrl: './icon-flag-geo.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFlagGeoComponent {}
